/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import "vant/es/checkbox-group/style";
import _CheckboxGroup from "vant/es/checkbox-group";
import "vant/es/checkbox/style";
import _Checkbox from "vant/es/checkbox";
import "vant/es/area/style";
import _Area from "vant/es/area";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/action-sheet/style";
import _ActionSheet from "vant/es/action-sheet";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "vant/es/sticky/style";
import _Sticky from "vant/es/sticky";
import "vant/es/datetime-picker/style";
import _DatetimePicker from "vant/es/datetime-picker";
import "vant/es/uploader/style";
import _Uploader from "vant/es/uploader";
import "vant/es/rate/style";
import _Rate from "vant/es/rate";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/search/style";
import _Search from "vant/es/search";
import "vant/es/form/style";
import _Form from "vant/es/form";
import "vant/es/calendar/style";
import _Calendar from "vant/es/calendar";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import "vant/es/cell/style";
import _Cell from "vant/es/cell";
import "vant/es/cell-group/style";
import _CellGroup from "vant/es/cell-group";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/lazyload/style";
import _Lazyload from "vant/es/lazyload";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/picker/style";
import _Picker from "vant/es/picker";
export default {
  install: function install(Vue, options) {
    Vue.use(_Picker);
    Vue.use(_Popup);
    Vue.use(_Toast);
    Vue.use(_PullRefresh);
    Vue.use(_Button);
    Vue.use(_Swipe).use(_SwipeItem);
    Vue.use(_Lazyload);
    Vue.use(_Field);
    Vue.use(_Cell).use(_CellGroup);
    Vue.use(_Notify);
    Vue.use(_List);
    Vue.use(_Calendar);
    Vue.use(_Form);
    Vue.use(_Search);
    Vue.use(_Icon);
    Vue.use(_Rate);
    Vue.use(_Uploader);
    Vue.use(_DatetimePicker);
    Vue.use(_Sticky);
    Vue.use(_Tab);
    Vue.use(_Tabs);
    Vue.use(_Loading);
    Vue.use(_ActionSheet);
    Vue.use(_Dialog);
    Vue.use(_Area);
    Vue.use(_Checkbox);
    Vue.use(_CheckboxGroup);
  }
};